import { Cell, Pie, PieChart, Tooltip } from "recharts";

export interface DatoTorta {
  clave: string;
  etiqueta: string;
  /** Valor ya en la unidad que se quiere repartir (ej. porcentaje escalado a 10^4: entero). */
  valor: number;
  color: string;
}

export interface GraficoTortaProps {
  etiqueta: string;
  datos: DatoTorta[];
  formatValor: (valor: number) => string;
}

/** Torta (dona) con leyenda. Colores en orden fijo desde la paleta categórica; 2px de separación entre porciones.
 *  Siempre acompañarla con una tabla de los mismos datos (es la vista accesible con los números). */
export function GraficoTorta({ etiqueta, datos, formatValor }: GraficoTortaProps) {
  return (
    <figure className="flex flex-col items-center gap-3">
      <div role="img" aria-label={etiqueta}>
        <PieChart width={220} height={220}>
          <Pie
            data={datos}
            dataKey="valor"
            nameKey="etiqueta"
            innerRadius={62}
            outerRadius={100}
            stroke="#ffffff"
            strokeWidth={2}
            isAnimationActive={false}
          >
            {datos.map((d) => (
              <Cell key={d.clave} fill={d.color} />
            ))}
          </Pie>
          <Tooltip formatter={(valor) => formatValor(Number(valor))} />
        </PieChart>
      </div>
      <ul aria-label="Referencias" className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-chico text-texto-suave">
        {datos.map((d) => (
          <li key={d.clave} className="flex items-center gap-1.5">
            <span aria-hidden className="size-2.5 shrink-0 rounded-full" style={{ backgroundColor: d.color }} />
            {d.etiqueta}
          </li>
        ))}
      </ul>
    </figure>
  );
}
